import { useMemo } from 'react';
import type { ViewEntity } from '@view-model/domain/view';
import type { ViewModelOperationLogSender } from '@model-framework/action-log';
import { useViewModelOperationLogSender } from '@model-framework/action-log';

export const useViewLogSender = (view: ViewEntity): ViewModelOperationLogSender => {
  const params = useMemo(() => ({ viewId: view.id, viewName: view.name.value }), [view.id, view.name.value]);
  return useViewModelOperationLogSender(params);
};
